import ChannelList from 'channels.json';

const DEFAULT_CHANNEL_ID = '11'; //Radio 1

export const getChannelDetailsById = (id = DEFAULT_CHANNEL_ID) => ChannelList.find(channel => channel.id === id);